import React from 'react';
import Chip from '@mui/material/Chip';
import { styled, darken } from '@mui/material/styles';

// Define color mapping for each status
const statusStyles = {
  /* Green */
  'Active': { backgroundColor: '#DBF0EE', color: '#4DB6AC' },
  'Valid': { backgroundColor: '#DBF0EE', color: '#4DB6AC' },
  'Opened': { backgroundColor: '#DBF0EE', color: '#4DB6AC' },
  'Accepted': { backgroundColor: '#DBF0EE', color: '#4DB6AC' },
  'Paid when Created': { backgroundColor: '#DBF0EE', color: '#4DB6AC' },
  'Paid': { backgroundColor: '#DBF0EE', color: '#4DB6AC' },
  'Approved': { backgroundColor: '#DBF0EE', color: '#4DB6AC' },
  'Published': { backgroundColor: '#DBF0EE', color: '#4DB6AC' },
  'Collected': { backgroundColor: '#DBF0EE', color: '#4DB6AC' },

  /* Blue */
  'New': { backgroundColor: '#D1E9FD', color: '#64B5F6' },
  'Pending': { backgroundColor: '#D1E9FD', color: '#64B5F6' },
  'Yes': { backgroundColor: '#D1E9FD', color: '#64B5F6' },
  'Pre': { backgroundColor: '#D1E9FD', color: '#64B5F6' },
  'Activity': { backgroundColor: '#D1E9FD', color: '#64B5F6' },

  /* Purple */
  'Posted': { backgroundColor: '#F1E1F4', color: '#BA68C8' },
  'KIV': { backgroundColor: '#F1E1F4', color: '#BA68C8' },
  'Submitted': { backgroundColor: '#F1E1F4', color: '#BA68C8' },
  'No': { backgroundColor: '#F1E1F4', color: '#BA68C8' },
  'Post': { backgroundColor: '#F1E1F4', color: '#BA68C8' },
  'Donation': { backgroundColor: '#F1E1F4', color: '#BA68C8' },

  /* Red */
  'Rejected': { backgroundColor: '#F6D9DE', color: '#D13F58' },
  'Voided': { backgroundColor: '#F6D9DE', color: '#D13F58' },
  'Inactive': { backgroundColor: '#F6D9DE', color: '#D13F58' },
};

// Default style for unknown statuses
const defaultStyle = {
  backgroundColor: '#E9E9E9',
  color: '#999999',
};

// Styled component for Chip based on status
const CustomChip = styled(Chip)(({ status }) => {
  const style = statusStyles[status] || defaultStyle;
  return {
    ...style,
    '&:hover': {
      backgroundColor: darken(style.backgroundColor, 0.05),
    },
  };
});

// Main StatusChip component
export default function StatusChip({ status, clickable = false, onClick }) {
  return (
    <CustomChip label={status || '-'} status={status} clickable={clickable} onClick={onClick}/>
  );
};